import axios, { type AxiosResponse } from 'axios'
import { ReplaySubject } from 'rxjs'
import { AppTranslations } from '../translations/translations'
import { AppConfigService } from './app-config.service'
import { InternalMessages } from 'src/app/config/internal-messages'
import { type AppTranslationConfig, SupportedLanguages } from '../models/app-translations.model'

export class TranslateService {
  /**
   * Public observable property: emit true when translation service ready
   */
  ready$ = new ReplaySubject<boolean>(1)

  private initialized = false
  private currentLang: SupportedLanguages = SupportedLanguages.En
  private static instance: TranslateService
  private translations: object = {}
  private readonly appConfigService: AppConfigService

  static getInstance(): TranslateService {
    if (TranslateService.instance === undefined) {
      TranslateService.instance = new TranslateService()
    }

    return TranslateService.instance
  }

  private constructor() {
    this.appConfigService = AppConfigService.getInstance()
  }

  /**
   * Public API method: init translate service
   */
  init(): void {
    if (!this.initialized) {
      this.currentLang = this.appConfigService.getInterfaceLang()

      this.initTranslations()
      this.initialized = true
    }
  }

  /**
   * Public API method: translate string
   */
  translate(originalString: keyof object): string {
    if (!this.translations[originalString]) {
      return originalString
    }

    return this.translations[originalString][this.currentLang]
      ? this.translations[originalString][this.currentLang]
      : originalString
  }

  private initTranslations(): void {
    this.loadInternalTranslations()
  }

  private loadInternalTranslations(): void {
    const translationData: AppTranslationConfig = AppTranslations

    this.updateTranslations(translationData)
  }

  private updateTranslations(data: object | AppTranslationConfig): void {
    this.translations = data
    this.ready$.next(true)
  }
}
